export default __webpack_public_path__ + "static/media/markdown.e6132422.md";